import { URLS } from '../shared/url';
import { Router } from '@angular/router';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { ProfileViewModel } from '../models/generated-view-models';
import { ResponseTypeEnum } from '../models/enums';
import { UserProfileService } from './user-profile.service';
import { Globals } from '../shared/globals';
import * as i0 from "@angular/core";
import * as i1 from "./base-http.service";
import * as i2 from "@angular/router";
import * as i3 from "./user-profile.service";
import * as i4 from "../shared/globals";
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(baseHttp, router, profileService, globals) {
        var _this = this;
        this.baseHttp = baseHttp;
        this.router = router;
        this.profileService = profileService;
        this.globals = globals;
        this._user = new ProfileViewModel();
        this.login = function (user) {
            return _this.baseHttp.Post(URLS.login, user, ResponseTypeEnum.Full);
        };
        this.logout = function () {
            return _this.baseHttp.Post(URLS.logout, null, ResponseTypeEnum.Success);
        };
        this.checkLogin = function (url) {
            if (_this.globals.isLoogedIn) {
                return true;
            }
            else {
                if (!_this.isAuthorized) {
                    _this.router.navigate(['login']);
                    return false;
                }
                return Observable.create(function (observer) {
                    _this.baseHttp.Post(URLS.tokenValidation, null, ResponseTypeEnum.Full).subscribe(function (res) {
                        if (res.result) {
                            _this.getUserProfile();
                            _this.globals.isLoogedIn = true;
                            url && _this.router.navigate([url]);
                            observer.next(true);
                        }
                        else {
                            _this.globals.isLoogedIn = false;
                            _this.router.navigate(['login']);
                            observer.next(false);
                        }
                        observer.complete();
                    }, function (err) {
                        _this.globals.isLoogedIn = false;
                        _this.router.navigate(['login']);
                        observer.next(false);
                        observer.complete();
                    });
                });
            }
        };
        this.getUserProfile = function () {
            _this.profileService.getUserProfile().subscribe(function (res) {
                _this.user = res;
            });
        };
        this.checkLogout = function () {
            if (_this.globals.isLoogedIn) {
                _this.router.navigate(['']);
                return false;
            }
            else {
                if (!_this.isAuthorized) {
                    return true;
                }
                return Observable.create(function (observer) {
                    _this.baseHttp.Post(URLS.tokenValidation, null, ResponseTypeEnum.Full).subscribe(function (res) {
                        if (res.result) {
                            _this.globals.isLoogedIn = true;
                            _this.router.navigate(['']);
                            observer.next(false);
                        }
                        else {
                            _this.globals.isLoogedIn = false;
                            observer.next(true);
                        }
                        observer.complete();
                    }, function (err) {
                        _this.globals.isLoogedIn = false;
                        observer.next(true);
                        observer.complete();
                    });
                });
            }
        };
        this.checkPasswordResetAviability = function (params) {
            if (params && params.token) {
                return Observable.create(function (observer) {
                    _this.baseHttp.Post(URLS.validateSecureLinkToken + "/" + params.token, null, ResponseTypeEnum.Full).subscribe(function (res) {
                        if (res.success && res.result.isValid) {
                            observer.next(true);
                        }
                        else {
                            _this.router.navigate(['login']);
                            observer.next(false);
                        }
                        observer.complete();
                    }, function (err) {
                        _this.router.navigate(['login']);
                        observer.next(false);
                        observer.complete();
                    });
                });
            }
            else {
                _this.router.navigate(['login']);
                return false;
            }
        };
        this.ResetPassword = function (request) {
            return _this.baseHttp.Post(URLS.resetPassword, request, ResponseTypeEnum.Full);
        };
    }
    Object.defineProperty(AuthenticationService.prototype, "isAuthorized", {
        get: function () {
            return !!localStorage.getItem('Authorization');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "user", {
        get: function () {
            return this._user;
        },
        set: function (value) {
            this._user = value;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.ngInjectableDef = i0.defineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.inject(i1.BaseHttpService), i0.inject(i2.Router), i0.inject(i3.UserProfileService), i0.inject(i4.Globals)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
